import { Outlet } from 'react-router-dom';

const WafBlockedLayout = () => {
  return <Outlet />;
};

export default WafBlockedLayout;
